// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__i5FxE","icons":"LoginForm_icons__uMrmC","forgotPassword":"LoginForm_forgotPassword__rQZMI"};